module.exports = __webpack_public_path__ + "static/img/101026.0fa30c3d.png";